import * as React from "react";
import InpectionErrandExecuteForm from "../../components/Forms/InspectionErrand/ExecuteForm/FlowForm";

export default function ExecuteInspectionErrand() {
  return <InpectionErrandExecuteForm method="PATCH" />;
}
